var Backbone = require('backbone');
var _ = require('underscore');

require('./IndexDownload.less');


module.exports = Backbone.View.extend({

    el: '.IndexDownload',

    events: {
        'click .IndexDownload-block': 'onDownloadClick'
    },


    initialize: function () {
    },


    show: function (data) {
        this.$el.addClass('visible');

        this.data = data;
    },


    hide: function () {
        this.$el.removeClass('visible');
    },


    onDownloadClick: function (e) {
        var $block = $(e.currentTarget);

        this.data.CraftID = $block.attr('data-craft');

        var apiUrl = Urls['availability:api:availability']('json');

        var $centerBlock = this.$('.IndexDownload-centerBlock');
        var $block = $(e.currentTarget);

        $centerBlock.addClass('IndexDownload-centerBlock--loading');
        $block.addClass('IndexDownload-block--loading');

        // if (app.settings.isDesktop) {
        var params = [];
        $.each(this.data, function (k, v) {
            params.push(k + '=' + encodeURIComponent(v));
        });

        $.fileDownload(apiUrl + '?' + params.join('&'), {
            successCallback: function (url) {
                $centerBlock.removeClass('IndexDownload-centerBlock--loading');
                $block.removeClass('IndexDownload-block--loading');
            },
            failCallback: function (html, url) {
                $centerBlock.removeClass('IndexDownload-centerBlock--loading');
                $block.removeClass('IndexDownload-block--loading');
            }
        });
        // } else {
        //     var $form = $('<form method="GET" action="' + apiUrl + '">');
        //     var $iframe = $('<iframe style="display:none"></iframe>');
        //     $.each(this.data, function(k, v) {
        //         $form.append($('<input type="hidden" name="' + k + '" value="' + v + '">'));
        //     });
        //     $iframe.append($form);
        //     $('body').append($iframe);
        //     $form.submit();

        //     setTimeout(function () {
        //         $centerBlock.removeClass('IndexDownload-centerBlock--loading');
        //         $block.removeClass('IndexDownload-block--loading')
        //     }, 2000);
        // }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/availability/components/IndexDownload/IndexDownload.js
// module id = 16
// module chunks = 0